export enum AuthRouteNameEnum {
	login = "auth.login",
	register = "auth.register",
	passwordRecovery = "auth.password-recovery",
	passwordReset = "auth.password-reset",
	mailConfirmation = "auth.mail-confirmation",
	confirmRegistration = "auth.confirm-registration"
}
